import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Media from "./media"
import TourDescription from "./tour-description"
import { ImagePropTypes } from "../core-image"

const InfoSideMenuHolder = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 500px) {
    margin-top: 16px;
  }
`

const ImageHero = styled.img`
  min-width: calc(100vw);
`
const ImageHolder = styled.div`
  position: relative;
  max-width: 100vw;
  overflow: show;
  translate: -18px 0;
  & > .banner {
    z-index: 2;
    font-size: 148x;
    font-weight: 700;
    line-height: 24px;
    position: absolute;
    width: 300px;
    text-align: center;
    top: 44px;
    left: -84px;
    padding: 10px 0;
    color: white;
    font-weight: bold;
    transform: rotate(-45deg);
    text-transform: uppercase;
    background-color: #3a6968; // Natasha
    &.sold-out {
      background-color: #cf2f43; // Natasha
    }
    clip-path: polygon(78px 0px, 222px 0px, 266px 100%, 35px 100%);
  }
`

const TourDescriptionHolder = styled.span`
  display: none;
  @media (max-width: 500px) {
    display: block;
    margin-top: 32px;
  }
`

const MobileHolder = styled.div`
  display: none;
  @media (max-width: 500px) {
    display: block;
  }
  max-width: 100vw;
`

const InfoSideMenuPart2 = ({ img, description, spotsRemaining }) => {
  return (
    <InfoSideMenuHolder>
      <MobileHolder>
        <Media />
        <ImageHolder>
          {spotsRemaining && (
            <div
              className={`banner ${
                spotsRemaining === "Sold Out" ? "sold-out" : "few-spots"
              }`}
            >
              {spotsRemaining}
            </div>
          )}
          <ImageHero src={img.src} alt={img.alt} />
        </ImageHolder>
      </MobileHolder>

      <TourDescriptionHolder>
        <TourDescription description={description} />
      </TourDescriptionHolder>
    </InfoSideMenuHolder>
  )
}

InfoSideMenuPart2.propTypes = {
  tourIcons: PropTypes.arrayOf(PropTypes.object),
  image: PropTypes.shape({ ...ImagePropTypes }),
  description: PropTypes.string,
  spotsRemaining: PropTypes.string,
}
export default InfoSideMenuPart2
